import { t } from '@lingui/core/macro';
import { BooleanFilter } from './BooleanFilter';
export const sharedExternallyFilterLabel = () => t({ message: 'Shared externally', comment: 'Insights: Shared externally filter' });
export function SharedExternallyFilter() {
    return <BooleanFilter name="metadataDocumentIsSharedExternally" label={sharedExternallyFilterLabel()}/>;
}
